<template>
  <v-dialog
    v-model="dialog"
    max-width="20rem"
    :fullscreen="$vuetify.breakpoint.xsOnly"
  >
    <template v-slot:activator="{ on }">
      <div v-on="on">
        <span>{{ item.quantity_received }}</span>
        <span class="caption ml-1">{{ item.mapped_unit }}</span>
      </div>
    </template>
    <v-card>
      <v-card-title>
        <v-row align="center" justify="end" no-gutters>
          <v-btn icon @click="dialog = false">
            <v-icon>fa-times</v-icon>
          </v-btn>
        </v-row>
      </v-card-title>
      <v-card-text class="mt-3 pt-3">
        <j-decimal-input
          class="mt-3 no-before"
          filled
          label="Quantité reçu"
          :suffix="item.mapped_unit"
          v-model="item.quantity_received"
        ></j-decimal-input>
      </v-card-text>
      <v-card-actions>
        <v-row align="center" justify="end" no-gutters>
          <v-btn
            :block="$vuetify.breakpoint.xsOnly"
            :large="$vuetify.breakpoint.xsOnly"
            color="success"
            @click="dialog = false"
          >
            <v-icon small left>fa-check</v-icon>
            Soumettre
          </v-btn>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "DeliverySlipViewerQuantityInput",
  props: {
    item: {
      required: true
    }
  },
  data() {
    return {
      dialog: false
    };
  }
};
</script>

<style></style>
